<div class="_snack-bar-container">
  <div class="_message">
    <mat-icon [svgIcon]="data.icon"></mat-icon>
    <span>
      {{ data.message }}
    </span>
  </div>
</div>
